/**
 * The click to accept undertaking shown before Tier 2 is released.
 *
 * The version string is NDA_VERSION from the contract and is never written out
 * here: what the customer accepts and what is recorded against them have to be
 * the same value. This file holds only the wording that goes with it.
 *
 * The wording below is drafted for review. It is deliberately short and states
 * nothing about our compliance position: the portal chrome makes no compliance
 * claim anywhere, and that content belongs in the documents behind this gate.
 * Legal should sign this off before launch, and any change to it needs
 * NDA_VERSION bumped in the contract so that earlier acceptances stay attached
 * to the text they were given.
 */

export const NDA_INTRO =
  'The documents in this group include our audit reports, penetration test results and internal policies. Before we release them, we need your agreement to the following.';

export const NDA_TERMS: readonly string[] = [
  'You will use these documents only to assess InsuredHQ as a supplier to your organisation.',
  'You will keep them confidential and share them only with colleagues who need them for that assessment, on the same terms.',
  'You will not publish, quote or redistribute them, and you will not pass them to a third party without our written consent.',
  'You will destroy or return your copies when your assessment is complete, or on our request.',
  'These obligations last for three years from the date you accept them.',
];

export const NDA_CLOSING =
  'Accepting below records your agreement. Copies you open are stamped with your email address and the time of access.';
